// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".current-product[data-v-3f67315f] {\n  color: #c56cf7;\n  position: absolute;\n  z-index: 9;\n  top: 1px;\n  right: -3px;\n  font-size: 12px;\n}\n.widget-rootwidget .trend-graph-cell[data-v-3f67315f] {\n  padding-bottom: 3rem;\n}\n.widget-rootwidget .trend-graph-container[data-v-3f67315f] {\n  position: relative;\n  padding-left: 0;\n  width: calc(100% - 1rem);\n}\n", ""]);
// Exports
module.exports = exports;
